<script>
import UiBadge from "@/components/ui/Badge.vue";

export default {
  name: "StatusTableRenderer",
  props: ["object"],
  components: {
    UiBadge,
  },
  props: ["object"],
};
</script>
<template>
  <span class="renderer">
    <UiBadge
      v-if="object.status === 'verified'"
      type="success"
    >
      {{ $t("remoteMonitoring.validation.verified") }}
    </UiBadge>
    <UiBadge
      v-if="object.status === 'waiting'"
      type="info"
    >
      {{ $t("remoteMonitoring.validation.waiting") }}
    </UiBadge>
    <UiBadge
      v-if="object.status === 'refused'"
      type="danger"
    >
      {{ $t("remoteMonitoring.validation.refused") }}
    </UiBadge>
  </span>
</template>
